$(document).ready(function(){

	$('.hero-slide').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Vorheriges</span></button>',
		nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Nächstes</span></button>',
		arrows: true,
		dots: true,
		autoplay: true,
		speed: 600,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 940,
				settings: {
					dots: true,
					arrows: true
				}
			}
		]
		/*responsive: [
			{
				breakpoint: 1400,
				settings: {
					dots: true,
					arrows: false
				}
			},
			{
				breakpoint: 640,
				settings: {
					dots: true,
					arrows: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
		*/
	});
	
});